import { observer } from "mobx-react-lite";
import { store } from "../../../../../stores/Store";
import { Button } from "@mui/material";
import { Alert, AlertModal } from "../../../../..";
import AutomationRunForm from "../../../../form/automation/AutomationRunForm";
import React from "react";
import Ajax from "../../../../../Ajax";
import { Icons } from "../../../../../misc/Icons";

interface AutomationCtaProps {
    enquiryUid?: string
    automationNodeUid: string;
}

export default observer(function AutomationCta({automationNodeUid, enquiryUid = null}: AutomationCtaProps) {
    
    const { getQualifyingOnlineForms } = store.AutomationStore
    const [loading, setLoading] = React.useState(true)
    const [enquiry, setEnquiry] = React.useState(null)
    const [automationOptions, setAutomationOptions] = React.useState(null)

    const getAutomationOptions = async () => {

        if (enquiryUid) {
            await Ajax.Node.Get(enquiryUid).then((response) => {
                var automationOptions = getQualifyingOnlineForms(response.data)
                setAutomationOptions(automationOptions)
                setEnquiry(response.data)
            }).catch(() => {
                Alert({message: "Failed to get Automation options"})
            })
        } else {
            setAutomationOptions([...store.AutomationStore.options])
        }

        setLoading(false)
    }

    React.useEffect(() => {
        getAutomationOptions()
    }, [])

    const message = () => {
        if (loading) {
            return "Loading Automation options..."
        }
        if (enquiry && enquiry.status !== "DEFINITIVE") {
            return "You must complete the enquiry before creating automations."
        }
        if (enquiry && !automationOptions?.length) {
            return `There are no Automation options for ${store.NodeStore.getDisplayName(enquiry)}.`
        }
        if (automationOptions?.length === 1) {
            return "We have found found a relevant Automation"
        }
        if (automationOptions?.length > 1) {
            return `We have found ${automationOptions.length} relevant online forms.`
        }

        return ""
    }

    if (store.AppStore.readOnly) return <></>
    
    return (
        <>
            <div className="section-subheader">
                <small>{message()}</small>
            </div>

            <Button
                color="success"
                className="btn btn-md"
                variant="contained"
                style={{margin: "8px"}}
                disabled={loading || !!store.AutomationStore.runningAutomation}
                onClick={async () => {
                    AlertModal({size: "auto", body: (
                        <AutomationRunForm 
                            enquiry={enquiry} 
                            automationNodeUid={automationNodeUid} 
                            automationOptions={automationOptions} />
                    )})
                }}>
                <Icons.Automation /> Create Automation
            </Button>
        </>
    )
})